import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import useSubscriptionStatus from '../../hooks/useSubscriptionStatus';
import { Loader2 } from 'lucide-react';

const SubscriptionProtectedRoute = ({ children, allowedRoles }) => {
  const { user, isLoading } = useAuth();
  const { hasActiveSubscription, isChecking } = useSubscriptionStatus();

  // Show loading while checking authentication or subscription
  if (isLoading || isChecking) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-primary-600 mx-auto mb-4" />
          <p className="text-gray-600">Checking subscription status...</p>
        </div>
      </div>
    );
  }

  // Check if user is authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has required role
  if (allowedRoles && !allowedRoles.includes(user.user_type)) {
    return <Navigate to="/" replace />;
  }

  // For vendors, check subscription status
  if (user.user_type === 'vendor') {
    if (hasActiveSubscription === false) {
      // Vendor is not subscribed, redirect to subscription page
      return <Navigate to="/vendor/subscription" replace />;
    }
    
    if (hasActiveSubscription === null) {
      // Still checking subscription status, show loading
      return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center">
            <Loader2 className="w-8 h-8 animate-spin text-primary-600 mx-auto mb-4" />
            <p className="text-gray-600">Verifying subscription...</p>
          </div>
        </div>
      );
    }
  }

  // User is authenticated, has correct role, and if vendor, has active subscription
  return children;
};

export default SubscriptionProtectedRoute;
